type Font = {
  parentFolder?: string;
  family: string;
  fileName: string;
  weight: string;
  isCondensed?: boolean;
  isItalic?: boolean;
};
type FontFormat = 'woff2' | 'woff';

const staticAssetDomain = 'https://static.marksandspencer.com/';
const mnsFontsUrl = `${staticAssetDomain}fonts/`;

type FontVariant =
  | 'regular'
  | 'semiBold'
  | 'msMarketRegular'
  | 'msMarketBold'
  | 'msMarketCondensed'
  | 'msBarrowRegular'
  | 'msBarrowBold';

const fonts: Record<FontVariant, Font> = {
  regular: {
    parentFolder: 'mnsLondon',
    family: 'New MS London',
    fileName: 'mnsLondonRegular',
    weight: '400',
  },
  semiBold: {
    parentFolder: 'mnsLondon',
    family: 'New MS London',
    fileName: 'mnsLondonSemiBold',
    weight: '600',
  },
  msMarketRegular: {
    parentFolder: 'msMarket',
    family: 'MSMarket-Regular-v4',
    fileName: 'MSMarket-Regular-v4',
    weight: '400',
  },
  msMarketBold: {
    parentFolder: 'msMarket',
    family: 'MSMarket-Bold-v4',
    fileName: 'MSMarket-Bold-v4',
    weight: '700',
  },
  msMarketCondensed: {
    parentFolder: 'msMarket',
    family: 'MSMarket-Condensed-v4',
    fileName: 'MSMarket-Condensed-v4',
    weight: '400',
  },
  msBarrowRegular: {
    parentFolder: 'msBarrow',
    family: 'MSBarrow-Regular-v2',
    fileName: 'MSBarrow-Regular-v2',
    weight: '400',
  },
  msBarrowBold: {
    parentFolder: 'msBarrow',
    family: 'MSBarrow-Bold-v2',
    fileName: 'MSBarrow-Bold-v2',
    weight: '700',
  },
};

const fontUrl = ({ fileName, parentFolder }: Font, format: FontFormat) =>
  `${mnsFontsUrl}${parentFolder}/${fileName}.${format}`;

const toPreloadLink = (font: Font, format: FontFormat): React.ReactElement => (
  <link
    rel="preload"
    href={`${fontUrl(font, format)}`}
    as="font"
    type={`font/${format}`}
    crossOrigin="anonymous"
    key={`${font.fileName}-${format}`}
  />
);

export const FontPreloadLinks = ({
  includedVariants = ['regular', 'semiBold'],
  format = 'woff2',
}: {
  includedVariants?: FontVariant[];
  format?: FontFormat;
}) => {
  return includedVariants
    .map((variant) => fonts[variant])
    .map((font) => toPreloadLink(font, format));
};
